module.exports = require("@amzn/awsui-components-react-v3");